import React, { useState } from "react";
import { Clock3, Mail, Upload, UserRound } from "lucide-react";
import "../../pages/AdminProfile.css";
import EditInfoContent from "./EditInfoContent";
import PasswordChangeContent from "./PasswordChangeContent";

const AdminProfileContent = ({ embedded = false }) => {
  const [activeTab, setActiveTab] = useState("profile");
  const [isEditInfoOpen, setIsEditInfoOpen] = useState(false);
  const [isPasswordOpen, setIsPasswordOpen] = useState(false);

  return (
    <main className={`admin-profile-main${embedded ? " embedded" : ""}`}>
      <nav className="profile-tabs" aria-label="Profile Tabs">
        <button
          type="button"
          className={activeTab === "profile" ? "tab-btn active" : "tab-btn"}
          onClick={() => setActiveTab("profile")}
        >
          Profile
        </button>
        <button
          type="button"
          className={activeTab === "login" ? "tab-btn active" : "tab-btn"}
          onClick={() => setActiveTab("login")}
        >
          Login History
        </button>
      </nav>

      {activeTab === "profile" && (
        <section className="account-card">
          <h2>Account Details</h2>

          <div className="account-details-row">
            <div className="upload-wrap">
              <label htmlFor="profile-upload" className="upload-circle">
                <span className="upload-head">
                  <Upload size={15} />
                  Upload
                </span>
                <span className="upload-help">Accepts .jpg, .jpeg, .png files</span>
              </label>
              <input id="profile-upload" type="file" accept=".jpg,.jpeg,.png" hidden />
            </div>

            <div className="detail-grid">
              <article className="detail-item">
                <div className="detail-label">
                  <UserRound size={15} />
                  <span>Name</span>
                </div>
                <p>superadmin</p>
              </article>

              <article className="detail-item">
                <div className="detail-label">
                  <Mail size={15} />
                  <span>Email Address</span>
                </div>
                <p>superadmin@blackroth.in</p>
              </article>

              <article className="detail-item">
                <div className="detail-label">
                  <Clock3 size={15} />
                  <span>Timezone</span>
                </div>
                <p>Indian/Maldives</p>
              </article>

              <article className="detail-item">
                <div className="detail-label">
                  <UserRound size={15} />
                  <span>Biography</span>
                </div>
                <p>-</p>
              </article>
            </div>
          </div>

          <div className="account-actions">
            <button
              type="button"
              className="btn-outline"
              onClick={() => setIsPasswordOpen(true)}
            >
              Change Password
            </button>
            <button
              type="button"
              className="btn-filled"
              onClick={() => setIsEditInfoOpen(true)}
            >
              Edit Info
            </button>
          </div>
        </section>
      )}

      {activeTab === "login" && (
        <section className="login-card">
          <h2>Login History</h2>
          <div className="login-list">
            <article className="login-row">
              <div>
                <h3>March 5, 2026</h3>
                <p>10:34 AM - Hyderabad, India</p>
              </div>
              <span className="status-pill">Successful</span>
            </article>
            <article className="login-row">
              <div>
                <h3>March 4, 2026</h3>
                <p>07:42 PM - Hyderabad, India</p>
              </div>
              <span className="status-pill">Successful</span>
            </article>
          </div>
        </section>
      )}

      {isEditInfoOpen && (
        <div className="profile-edit-modal-overlay" onClick={() => setIsEditInfoOpen(false)}>
          <div className="profile-edit-modal" onClick={(event) => event.stopPropagation()}>
            <div className="profile-edit-modal-head">
              <h3>Edit Profile</h3>
              <button
                type="button"
                className="profile-edit-close"
                onClick={() => setIsEditInfoOpen(false)}
                aria-label="Close edit profile popup"
              >
                x
              </button>
            </div>
            <div className="profile-edit-modal-content">
              <EditInfoContent embedded />
            </div>
          </div>
        </div>
      )}

      {isPasswordOpen && (
        <div className="profile-edit-modal-overlay" onClick={() => setIsPasswordOpen(false)}>
          <div className="profile-edit-modal" onClick={(event) => event.stopPropagation()}>
            <div className="profile-edit-modal-head">
              <h3>Change Password</h3>
              <button
                type="button"
                className="profile-edit-close"
                onClick={() => setIsPasswordOpen(false)}
                aria-label="Close change password popup"
              >
                x
              </button>
            </div>
            <div className="profile-edit-modal-content">
              <PasswordChangeContent embedded />
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default AdminProfileContent;
